const ConnectableResourcesRenderer = require("../common/ConnectableResourcesRenderer");
const Utils = require("../common/Utils");

/**
 * @extends {ConnectableResourcesRenderer}
 * @constructor
 */
function DynAppsRenderer() {
    ConnectableResourcesRenderer.call(this);
    const self = this;
    const super_render = this.render;

    function getEnabledWithTimeBadge(size) {
        return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 32 32" class="enabledWithTime">' +
            '<circle cx="16" cy="16" r="15" fill="green" stroke-width="1" stroke="white" />' +
            '<path d="M5,14 L12,21 25,8" fill="none" stroke="white" stroke-width="4" />' +
            '<circle cx="21" cy="21" r="6" stroke-width="1" stroke="green" fill="white" />' +
            '<circle cx="21" cy="21" r="4" fill="green" />' +
            '<path d="M21,16 L21,21 23,23" stroke="white" stroke-width="1" fill="green"/>' +
            "</svg>";
    }

    function getEnabledBadge(size) {
        return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 32 32" class="enabled">' +
            '<circle cx="16" cy="16" r="15" fill="green" stroke-width="1" stroke="white" />' +
            '<path d="M6,15 L13,22 25,10" fill="none" stroke="white" stroke-width="4" />' +
            "</svg>";
    }

    function getDisabledBadge(size) {
        return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 32 32" class="disabled">' +
            '<circle cx="16" cy="16" r="15" fill="#C00000" stroke-width="2" stroke="white" />' +
            '<path d="M12,8 a9,9 0 1,0 8,0" fill="none" stroke="white" stroke-width="4" />' +
            '<line x1="16" y1="5" x2="16" y2="15" stroke="white" stroke-width="4" />' +
            "</svg>";
    }

    function getStateBadge(resource, size) {
        if (resource.state === "Enabled") {
            if (resource.time_left > 0) {
                return getEnabledWithTimeBadge(size);
            }
            return getEnabledBadge(size);
        }
        return getDisabledBadge(size);
    }

    /**
     * @override
     */
    this.render = function(resource, dontScale, renderers) {
        const renderer = renderers[resource.subtype];
        if (renderer === undefined || self.hasCustomIcon(resource)) {
            // Call the ConnectableResourcesRenderer (Dynamic Firewall Rules/any resource with a custom icon)
            return super_render(resource);
        }

        // Render the standard icon of the base resource
        const $div = renderer.renderStandardIcon(resource, dontScale);
        $div.append(self.renderStateBadge(resource));
        return $div;
    };

    /**
     * @override
     */
    this.renderResourceListViewBadge = function(resource) {
        return getStateBadge(resource, this.getListViewBadgeSize());
    };

    /**
     * @override
     *
     * Overrides the base method in ConnectableResourcesRenderer to do nothing
     */
    this.updateIcon = function(element, resource) {};

    /**
     * @override
     *
     * Overrides the base method in ConnectableResourcesRenderer to do nothing
     */
    this.getStateClass = function(resource) {};

    /**
     * @override
     */
    this.renderStateBadge = function(resource) {
        const $div = $("<div>", {class : "resourceBadgeContainer dyn_app_state"});
        $div.append(getStateBadge(resource, this.getIconViewBadgeSize()));
        return $("<div>", {class : "ui-li-thumb connectionOverlay"}).append($div);
    };
}

Utils.inherits(DynAppsRenderer, ConnectableResourcesRenderer);

module.exports = DynAppsRenderer;
